const subscriptionManifest = Object.freeze({
  pluginKey: 'subscription',
  pluginVersion: '1.0.0',
  label: 'Subscription',
  availability: 'active',
  configSchemaVersion: 1,
  supportedStrategies: Object.freeze(['direct', 'broadcast']),
  qualificationModes: Object.freeze(['legacy_subscribed_boolean']),
  fields: Object.freeze([
    { key: 'qualification_mode', label: 'Qualification mode', type: 'compatibility' },
    { key: 'expected_currency', label: 'Currency', type: 'currency' },
    { key: 'hold_duration_days', label: 'Hold duration', type: 'number' },
  ]),
});

const registry = Object.freeze([subscriptionManifest]);

export const getGoalRegistry = () => registry;

export const getGoalManifest = (pluginKey, pluginVersion = '1.0.0') => (
  registry.find((entry) => entry.pluginKey === pluginKey && entry.pluginVersion === pluginVersion)
  || {
    pluginKey,
    pluginVersion,
    label: `${pluginKey} ${pluginVersion}`,
    availability: 'unknown',
    configSchemaVersion: null,
    supportedStrategies: [],
    fields: [],
    unknownVersion: true,
  }
);

export const readGoalSnapshot = ({ pluginKey, pluginVersion = '1.0.0', configSchemaVersion = null, config = {} }) => {
  const manifest = getGoalManifest(pluginKey, pluginVersion);
  const unknownVersion = Boolean(manifest.unknownVersion);
  return {
    ...manifest,
    configSchemaVersion,
    config: { ...config },
    unknownVersion,
    editable: !unknownVersion && manifest.availability === 'active',
    publishable: !unknownVersion && manifest.availability === 'active',
  };
};

export { subscriptionManifest };
